import { css } from 'styled-components';
import {
  getTypography, TypographyName,
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H3)};
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
  font-weight: normal;
`;

export const noResult: ThemedFunctor = ({ theme }) => css`
  height: 40vh;
  text-align: center;

  p {
    ${getTypography(theme, TypographyName.BODY)}
    ${getSpacing.margin(theme, [SpacingName.BIG, 0])}
  }
`;

export const item: ThemedFunctor = ({ theme }) => css`
  border-bottom: 1px solid ${theme.palettes.neutrals.light};

  &:first-of-type {
    border-top: 1px solid ${theme.palettes.neutrals.light};
  }

  &:last-of-type {
    border-bottom: 0;
  }
`;

export const breadcrumb: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, 0])}
  border-top: 1px solid ${theme.palettes.neutrals.light};
`;
